/* global Events, urlHistory, ANIMATIONS, runningMode, Login */

var CONTENT_TARGET = {
  /**
   * Stores point to target Node from DOM. Will be filled in <i>init()</i>
   * @type Node
   */
  _targetDOMPointer: null,
  /**
   * Search target node element from DOM and set the pointer to
   * <i>this.target</i>.
   * @returns {Promise}
   */
  init: function () {
    return new Promise((resolve, reject) => {
      this._targetDOMPointer = document.querySelector(
        "main.mdl-layout__content"
      );
      if (this._targetDOMPointer === null) {
        console.error("CONTENT_TARGET could not find main.mdl-layout__content");
        throw new Error("CONTENT_TARGET invalid");
      }

      resolve();
    });
  },
  /**
   * Change the current view.<br/>
   * Calls <i>close()</i> on old view before removing it from DOM.<br/>
   * Scrolls <i>main</i> to top.
   * @param {object} content_object
   * New view from <i>CONTENT</i>
   * @param {object} data
   * Will be given to call of <i>content_object.init(data)</i>
   * @param {object} animation
   * Animation wich will be used to hide current elements.<br/>
   * Has to have 2 parameters.<br/>
   * 1: {NodeList} Node elements to remove<br/>
   * 2: {function} callback
   * @param {object} options
   * disableUrlPushState, replaceView
   * @returns {undefined}
   */
  changeContent: function (content_object, data, animation, options) {
    var that = this;
    if (typeof options === "undefined") options = {};

    //remove view from DOM
    this._clear(animation, function () {
      //scroll main to top
      that._targetDOMPointer.scrollTop = 0;

      //History API call
      if (options.replaceView) urlHistory.replace(content_object, data);
      else if (options.disableUrlPushState) null;
      //do not push any state to History API
      else urlHistory.push(content_object, data); //default

      //generate new view and append to DOM
      CONTENT_TARGET._fillWithHTML(content_object, data);
    });
  },
  /**
   * Notify old view it will be closed. Unbinds event hander. Remove old view
   * from DOM.
   * @param {object} animation
   * Has to have 2 parameters.<br/>
   * 1: {NodeList} Node elements to remove<br/>
   * 2: {function} callback<br/>
   * If you do not want any animation, use <i>null</i>.
   * @param {function} callback
   * Will be executed after removing Nodes from DOM.
   * @returns {undefined}
   */
  _clear: function (animation, callback) {
    //current content is on first call null
    if (this.currentContent === null) {
      callback();
      return;
    }

    //notify view that it will be closed. No wait for async tasks
    this.currentContent.close();

    //animation
    if (animation === undefined)
      animation = ANIMATIONS.getDefaultHidingAnimation();
    if (typeof animation === "function") {
      animation(
        document.querySelectorAll(
          "#" + this.currentContent.css_id + " .changeViewAnimation"
        ),
        function () {
          removeElements();
          if (typeof callback === "function") callback();
        }
      );
      return;
    }

    //if no animation
    removeElements();
    callback();

    /**
     * Removes all Nodes from DOM in content target
     * @returns {undefined}
     */
    function removeElements() {
      /**
       * Normaly it has to be just one Node. But just in case use an loop.
       * @type object
       */
      var domPointer = CONTENT_TARGET._targetDOMPointer;
      var nodesToRemove = domPointer.children;
      for (var i = 0, len = nodesToRemove.length; i < len; i++)
        domPointer.removeChild(nodesToRemove[i]);
    }
  },
  /**
   * Append HTML code to <code>target</code> generated from <code>content_object</code>
   * and calls <code>content_object.init(data)</code>.
   * @param {object} content_object
   * New view from <i>CONTENT</i>
   * @param {object} data
   * Will be given to call of <i>content_object.init(data)</i>
   * @returns {undefined}
   */
  _fillWithHTML: function (content_object, data) {
    //generate html of new view and add it to content target
    this._targetDOMPointer.insertAdjacentHTML(
      "beforeend",
      this._generateHTML(content_object)
    );

    //add event handlers of new view
    Events.generate(content_object);

    this.currentContent = content_object;

    //notify new view about initializing
    content_object.init(data);
  },
  /**
   * Generates the HTML code from <i>content_object</i>
   * @param {object} content_object
   * New view from <i>CONTENT</i>
   * @returns {String|Boolean} <i>false</i> on error.
   */
  _generateHTML: function (content_object) {
    return (
      '<div id="' +
      content_object.css_id +
      '" class="content"  align="center">' +
      content_object.html +
      "</div>"
    );
  },
  currentContent: null,
  /**
   * Reloads the current view with their current data. Use this after login or logout.
   * @returns {undefined}
   */
  reloadView: function () {
    this.changeContent(this.currentContent, this.currentContent.data);
  },
  /**
   * Call this if user access a view without having access to it and you do not now how you schould redirect the user.
   * Shows the login menu. After login the view will be reloaded.
   * @param {Function} fail
   * Callback to call if login not successeded.
   * Do not use <i>window.history.back()</i>: User could be redirected to website before.
   * It's recomended to change the view here.
   * @returns {undefined}
   */
  permissionDenied: function (fail) {
    var that = this;
    this._clear();
    Login.login(undefined, function () {
      if (typeof fail === "function") return fail();

      //if login fail try to load default view
      var startContent = runningMode.mode.startContent.content;
      if (startContent !== that.currentContent)
        that.changeContent(startContent);
      else
        console.warn(
          "Hummingbird is not able to redirect to another view. You are in start view and have no permission. User can change view with navigation."
        );
    });
  },
};

/* ----------- CONTENT functions START ------------- */

/**
 * Returns all Objects and named uppder case. Normaly content objects. Be
 * aware, this function do not copy something; they are the original
 * Objects. Exept 'MODEL'.
 * @param {type} object
 *      Object to inspect
 * @returns {Array}
 */
function getAllContentFromObject(object) {
  var pages = {};
  for (var i in object) {
    if (i === i.toUpperCase() && typeof object[i] === "object" && i !== "MODEL")
      pages[i] = object[i];
  }
  return pages;
}

/* ----------- CONTENT functions END ------------- */
